export default function PHP_simplexml_load_file() {
  return (
    <div>
      <h1>PHP_simplexml_load_file</h1>
    </div>
  );
}
